'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var Header = require('./Header/Header.js');
var handlePhoneNumber = require('../../utils/handlePhoneNumber.js');
var Login = require('./Login.js');
require('../../styles/index.scss.js');
require('../../../node_modules/react-responsive-modal/styles.css.js');
var Button = require('../Button/Button.js');
require('../../../node_modules/classnames/index.js');
require('../ButtonGroup/ButtonGroup.scss.js');
require('../Badge/Badge.scss.js');
require('../Label/Label.scss.js');
require('../Checkbox/Checkbox.scss.js');
require('../Icon/Icon.scss.js');
require('../Button/helper.scss.js');
require('../Switch/Switch.scss.js');
require('../Radio/Radio.scss.js');
require('../Loader/Loader.scss.js');
require('../Input/Input.scss.js');
require('../Footer/Footer.scss.js');
require('../Navbar/Navbar.js');
require('../Navbar/MobileNavigation/styles.scss.js');
require('../../../node_modules/pure-react-carousel/dist/index.es.js');
require('../Carousel/Carousel.scss.js');
require('../../../node_modules/pure-react-carousel/dist/react-carousel.es.css.js');
require('../Pagination/Pagination.scss.js');
require('../Modal/Modal.scss.js');
require('../DropDown/DropDown.scss.js');
require('../Accordion/Accordion.scss.js');
require('../Stepper/Stepper.scss.js');
require('../Tabs/Tabs.scss.js');
require('../BottomNavigation/FooterNavigation/Tools/Tools.scss.js');
require('../BottomNavigation/FooterNavigation/Insurance/Insurance.scss.js');
require('../BottomNavigation/FooterNavigation/Account/Account.scss.js');
require('../BottomNavigation/FooterNavigation/Explore/Explore.scss.js');
require('../BottomNavigation/FooterNavigation/FooterNavigation.scss.js');
require('../../utils/hooks/canUseWebp.js');
require('../BottomNavigation/BottomNavigation.scss.js');
require('../ViewMore/ViewMore.scss.js');
require('../MFELogin/index.js');
require('../Swiper/index.js');
require('../Alert/Alert.scss.js');
require('../Loader/LifepalLoader.js');
require('../SEOAccordion/SEOAccordion.scss.js');
require('../Skeleton/index.js');
require('../LifepalProvider/LifepalProvider.js');
require('react-dom');
require('../../../node_modules/react-responsive-modal/node_modules/classnames/index.js');
require('../../../node_modules/body-scroll-lock/lib/bodyScrollLock.esm.js');
require('../ResponsiveModal/style.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var OTPForm = function (props) {
    var previous = props.previous, isModal = props.isModal;
    var _a = Login.useLoginContext(), phoneNumber = _a.phoneNumber, verificationOtp = _a.verificationOtp, resendOtp = _a.resendOtp, timeLeft = _a.timeLeft, buttonResendId = _a.buttonResendId, backToPrev = _a.backToPrev;
    var _b = React.useState([]), otpCode = _b[0], setOtpCode = _b[1];
    var _c = React.useState(false), resend = _c[0], setResend = _c[1];
    var _d = React.useState(timeLeft || 30), time = _d[0], setTime = _d[1];
    var autoTab = function (e) {
        var tabIndex = e.currentTarget.tabIndex || 0;
        var BACKSPACE_KEY = 8;
        var DELETE_KEY = 46;
        var tabindex = Number(tabIndex);
        if (e.keyCode === BACKSPACE_KEY) {
            tabindex -= 1;
        }
        else if (e.keyCode !== DELETE_KEY) {
            tabindex += 1;
        }
        var elem = document.getElementsByClassName("inputs-" + tabindex);
        if (elem[0]) {
            var nextElem = elem[0];
            nextElem.focus();
        }
    };
    var onInputChange = function (e, idx) {
        var otp = otpCode;
        otp[idx] = e.target.value;
        setOtpCode(otp);
    };
    var getOtp = function () { return tslib_es6.__awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return tslib_es6.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, resendOtp(handlePhoneNumber.handlePhoneNumber(phoneNumber))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [2 /*return*/];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        setTime(timeLeft || 30);
        if (!resend) {
            var secondsLeft_1 = setInterval(function () {
                setTime(function (c) {
                    if (c <= 1) {
                        setResend(true);
                    }
                    return c - 1;
                });
            }, 1000);
            return function () { clearInterval(secondsLeft_1); };
        }
    }, [resend]);
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        !isModal && React__default['default'].createElement(Header, { showBackBtn: true, isModal: isModal, onBackBtnClick: function () { return backToPrev(previous); } }),
        React__default['default'].createElement("div", { className: isModal ? 'form--modal' : 'form' },
            isModal && React__default['default'].createElement(Header, { showBackBtn: true, isModal: isModal, onBackBtnClick: function () { return backToPrev(previous); } }),
            React__default['default'].createElement("div", { className: 'verification bottom-13p' },
                React__default['default'].createElement("span", null, "Verifikasi Nomor Telepon"),
                React__default['default'].createElement("span", null, "Masukkan 6-digit code yang dikirim ")),
            React__default['default'].createElement("div", { className: 'otp-verification bottom-13p' }, tslib_es6.__spreadArrays(Array(6)).map(function (_, idx) {
                return (React__default['default'].createElement("input", { className: "inputs-" + idx, onChange: function (e) { onInputChange(e, idx); }, tabIndex: idx, key: idx, maxLength: 1, onKeyUp: autoTab }));
            })),
            resendOtp &&
                React__default['default'].createElement("div", { className: 'text-center register-now bottom-24p' },
                    React__default['default'].createElement("span", { className: !resend ? 'hidden' : '' }, "Tidak Menerima OTP?"),
                    React__default['default'].createElement("span", { className: !resend ? 'hidden' : '', id: buttonResendId || 'resend-otp', onClick: function () { if (resend) {
                            getOtp().then(function () { setResend(false); });
                        } } }, " Kirim Ulang."),
                    !resend &&
                        React__default['default'].createElement("span", { className: 'text-disabled' }, "Kirim ulang OTP " + time + " Detik lagi")),
            React__default['default'].createElement(Button.Button, { id: 'button-verification', className: 'action-button', onClick: function () { verificationOtp(otpCode.join('')); } }, "Verifikasi"))));
};

exports.OTPForm = OTPForm;
//# sourceMappingURL=OTPForm.js.map
